import { types } from 'mobx-state-tree';
import { navigate } from 'js/services/Network';
import { upperFirst, once } from 'lodash';

import AppState from 'js/stores/AppState';

const noop = () => false;
const isComplete = () => true;

let steps = [];
let pageRoute;

export default types
  .model({
    isLoaded: false,
    isSubmitting: false,
    error: types.maybeNull(types.string),
    currentStep: 0,
    latestStep: 0,
    hasStartedFlow: false,
  })
  .views(self => ({
    get step() {
      return steps[self.currentStep];
    },
    get steps() {
      return steps;
    },
    get pageRoute() {
      return pageRoute;
    },
  }))
  .actions(self => {
    let calledOnLeave = false;
    let pageName;
    let backNav;

    function findStep(stepName) {
      return steps.reduce(
        (currentStep, stepToCheck, index) => (stepToCheck.name === stepName ? index : currentStep),
        self.currentStep,
      );
    }

    return {
      setSteps(componentInstance, basePageRoute, pageSteps) {
        pageName = componentInstance.pageName || 'SteppedPage';
        backNav = componentInstance.backNav || { mode: 'normal' };
        pageRoute = basePageRoute;

        steps = pageSteps.map(step =>
          Object.assign({}, step, {
            skipWhen: once(step.skipWhen || noop),
            isComplete: step.isComplete || isComplete,
            onEnter: step.onEnter || noop,
            onLeave: step.onLeave || noop,
            route: self.getStepRoute(step.name),
          }),
        );

        return self;
      },

      _markAsLoaded() {
        self.isLoaded = true;
        return self;
      },

      setupNav() {
        const prevStep = steps[self.currentStep - 1];
        if (prevStep) {
          // show back nav
          AppState.setNav({
            mode: 'back',
            text: prevStep.label || upperFirst(prevStep.name),
            url: prevStep.route,
          });
        } else {
          // show page nav
          self.isLoaded && AppState.setNav(typeof backNav === 'function' ? backNav() : backNav);
        }
        return self;
      },

      gotoStep(stepIdentifier) {
        const destinationStep = typeof stepIdentifier === 'number' ? stepIdentifier : findStep(stepIdentifier);
        AppState.currentPage !== 'CreateNewPaymentLinkPage' ?
          window.scrollTo(0, 0) : null;

        if (destinationStep > 0 && !self.hasStartedFlow) {
          // at initial load, force user to start at beginning
          navigate(steps[0].route, { replace: true });
          return self;
        }

        // go to the destinationStep
        const lastStep = self.currentStep;
        self.currentStep = destinationStep;

        if (self.currentStep > self.latestStep) {
          self.latestStep = self.currentStep;
        }

        // call step lifecycle hooks
        if (!calledOnLeave && self.currentStep !== lastStep && steps[lastStep]) {
          steps[lastStep].onLeave(self, steps[lastStep]);
        }
        self.step.onEnter(self, self.step);

        calledOnLeave = false;
        // return (self.setupNav().initStep || noop)(self.step);
        return (self.initStep || noop)(self.step);
      },

      nextStep() {
        console.log('next');
        self.hasStartedFlow = true;
        AppState.setPreviousPage(pageName);

        if (!calledOnLeave) {
          self.step.onLeave(self, self.step);
          calledOnLeave = true;
        }

        const step = steps.slice(self.currentStep + 1).reduce((nextStep, step) => {
          if (!nextStep && !step.skipWhen(self, step)) {
            return step;
          }
          return nextStep;
        }, null);

        if (step === null) {
          self.submit();
        } else {
          navigate(step.route);
        }

        return self;
      },
    };
  });
